import React, { useContext, useEffect } from 'react'
import { AuthContext } from '../../context/auth'
import Sidebar from '../Sidebar'
import Notification from '../Notification'
import AddressModal from '../modals/addressModal'
import LogOutModal from '../modals/LogOutModal'

const Index = ({ children }) => {
  const {isLoading, notification, setNotification, openAddressModal, setOpenAddressModal, logOutModal } = useContext(AuthContext)


  useEffect(() => {
    if (notification) {
      setTimeout(() => {
        setNotification(null)
      }, 5000)
    }
  }, [notification])


  return (
    <>
      {notification && <Notification message={notification.message} subMessage={notification.subMessage} type={notification.type} onClick={() => setNotification(null)} />}
      <div style={{ width: '100%', display: 'flex' }}>
        <Sidebar />
        <main style={{ height: '100vh', width: '100%', overflowY: 'hidden' }}>
          {children}
        </main>
      </div>
      {openAddressModal && <AddressModal openAddressModal={openAddressModal} setOpenAddressModal={setOpenAddressModal} />}
      {logOutModal && <LogOutModal /> }
    </>
  )
}

export default Index